import { Component, inject } from '@angular/core';
import { CiamService } from 'src/app/services/CIAM/ciam.service';
import { WaitingComponent } from '../waiting/waiting.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-login-landing',
  imports: [WaitingComponent],
  templateUrl: './login-landing.component.html',
  styleUrl: './login-landing.component.scss',
})
export class LoginLandingComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private ciamService = inject(CiamService);

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      if (params['flow'] === 'mmb') {
        const baseUrl = window.location.origin;
        const url = "/payment/BookingCard";
        localStorage.setItem('returnUrl', url);
        localStorage.setItem('flow', params['flow'])
        localStorage.setItem('orderId', params?.['orderid'])
        this.ciamService.login();
        // this.router.navigate(['/login'])
      } else {
        this.ciamService.login();
      }
    });

  }
}
